'use strict';

import * as Onyx from '../lib/onyx.min.js';
import { default as MatterJSEntity } from './base-matter';

const MOMENTUM_THRESHOLD = 0.1;

const COLLISION_CATEGORY = 0x0002;
const COLLISION_MASK = 0x0001 | 0x0008; // GROUND | MOUSE | TAKO
const COLLISION_MASK_AFTERLAUNCH = 0x0001 | 0x0004; // GROUND | TAKO

const SCALE = 0.5;

export default class Player extends MatterJSEntity {
    constructor(position = [0,0], scale = 1, rotation = 0, { matterEngine = null, translateX = -40 * SCALE, rotateY = -20 * (Math.PI / 180) } = {}){
        super(matterEngine, position, [1, 1], rotation, Matter.Bodies.rectangle(position[0], -position[1], (120 * SCALE) * scale, (75 * SCALE) * scale, { density: 10.0, gravityScale: 0, friction: 0.75 }));

        this.physicsEnabled = false;
        this.canPlaySound = true;

        let modelRNG = Math.floor(Math.random() * 3);
        let modelName = "";

        switch(modelRNG){
            case 0:
                modelName = "fish1";
                break;
            case 2:
                modelName = "fish3";
                break;
            case 1:
            default:
                modelName = "fish2";
                break;
        }
        
        Onyx.ImportModelFromOnyx.load({src: "res/models/" + modelName + ".oxm"}).then((model) => {
            this.addComponent(model);

            this.components[0].meshes[0].material.ambientTexture = this.parentScene.caustic;
            this.components[0].meshes[0].material.buildProgram();

            this.components[0].animationClips[0].enabled = true;
           
            this.components[0].transform.translateX(translateX);
            this.transform.scaleTo(scale * SCALE, scale * SCALE, scale * SCALE);
            this.components[0].transform.rotateToY(rotateY);
        });

        if(this.body){
            this.body.collisionFilter.category = COLLISION_CATEGORY;
            this.body.collisionFilter.mask = COLLISION_MASK_AFTERLAUNCH;
        }
    }

    update(...args){
        super.update(...args);

        if(!this.body) return;

        // If player somehow falls off the map, don't wait
        if(this.transform.y < 0){
            this.waitForSleep = false;
        }else{
            this.waitForSleep = true;
        }

        if(!this.physicsEnabled){
            this.transform.rotateToZ(0);
        }

        // Keep upright
        if(Math.abs(this.body.angle) > 0.001){
            // this.body.torque = ((this.body.angle < 0)?1:-1) * 0.01;
        }
    }
    
    @Onyx.handles("oncollide")
    oncollide(event){
        // game.sfx['octopusSqueak'].volume((event.relativeMomentum / MOMENTUM_THRESHOLD) / 4);
        // game.sfx['octopusSqueak'].play();

        if(event.relativeMomentum > MOMENTUM_THRESHOLD && this.canPlaySound){
            game.sfx['impactsplat04'].play();
            this.canPlaySound = false;

            this.parentScene.setTimeout(() => {
                this.canPlaySound = true;
            }, 250);
        }

        // console.log(event.event);

        if((isNaN(event.relativeMomentum) || event.relativeMomentum > MOMENTUM_THRESHOLD) && !this.isLanded){
            this.isLanded = true;

            // Matter.Body.setInertia(this.body, 1000);
        }
    }

    enableDrag(){
        // Enable drag
        this.body.collisionFilter.mask = COLLISION_MASK;

        // Move to the slingshot
        Matter.Body.setPosition(this.body, {x: this.parentScene.slingshot.transform.x, y: -this.parentScene.slingshot.transform.y});

        // Bind to slingshot
        this.parentScene.slingshot.attachAmmo(this.body);
    }
    
    @Onyx.handles("launched")
    disableDrag(){
        this.body.collisionFilter.mask = COLLISION_MASK_AFTERLAUNCH;
    }
}